var _style, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNumber2Red(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D52B1E;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 72,
    cy: 72,
    r: 72
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.6,98.2c0-6.8,6.5-16,16.4-22.8l12.2-8.7c4.8-3.3,9.9-8.7,9.9-13.7c0-6-4.4-10.6-12.4-10.6 c-7,0-11.6,4.7-13,10l-16.2-2.8c2.3-11.4,13.1-21.7,28.8-21.7c17.8,0,28.8,10.3,28.8,24.9c0,10-5.9,17.3-15.3,24.1L73,84.8 c-4.5,3.1-7.7,6.8-9.4,11.1h36.6v13.8H44.6L44.6,98.2L44.6,98.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber2Red);
export default __webpack_public_path__ + "static/media/Number-2-Red.1f981b18cd6af0ed82b1962fd5152185.svg";
export { ForwardRef as ReactComponent };